module.exports = __webpack_public_path__ + "static/media/25-1.531a015e.mp3";